(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let THRESHOLD = 0.15;
  let ROOT_MARGIN = '0px 0px -60px 0px';

  let observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: THRESHOLD,
    rootMargin: ROOT_MARGIN
  });

  function observe() {
    document.querySelectorAll('[data-animate]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener('sections:reloaded', observe);
  document.addEventListener('cart:updated', observe);
})();
